import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { createTheme, ThemeProvider } from '../styles';
import defaultTheme from './defaultTheme';
import { deepMerge } from './deepMerge';
interface Props {
  children: ReactNode;
  overrides?: any;
}
const getTheme = (overrides: any) => overrides ? createTheme(deepMerge(defaultTheme, overrides)) : createTheme(defaultTheme as any);
const Theme = t0 => {
  const $ = _c(5);
  const {
    children,
    overrides
  } = t0;
  let t1;
  if ($[0] !== overrides) {
    t1 = getTheme(overrides);
    $[0] = overrides;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <ThemeProvider theme={t1}>{children}</ThemeProvider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default Theme;